import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import classNames from "classnames";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SearchIcon from "@mui/icons-material/Search";
import { ArrowBackSharp } from "@mui/icons-material";
import HomeIcon from '@mui/icons-material/Home';
import { useData } from "../../services/DataContext";
import MenuLogin from "../HeaderUser/HeaderUser";
import { statesStore } from "../../store/statesStore";

const SideBar = () => {
  const { sideBarDataset } = useData();
  const [dropdownOpen, setDropdownOpen] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const [toggleButton, setToggleButton] = useState(true);
  const [selectedIndicador, setSelectedIndicador] = useState(null);

  function handleClickCloseMenu() {
    setToggleButton(prevToggleButton => !prevToggleButton)
  }

  const toggleSideClassRecoilButton = classNames(
    'bg-primary text-white p-1 rounded-full shadow-md  cursor-pointer fixed top-[15vh] ml-[-16px] z-50 hover:bg-dark-primary ease-in-out h-8 flex', {
    'rotate-180 left-[16px] md:left-[16px] ml-0 ': !toggleButton,
    'left-[70vw] md:left-[30vw] xl:left-[20vw]': toggleButton,
  }
  );


  const toggleSideClass = classNames(
    'sidebar select-none items-center bg-white sticky w-screen', {
    'active-sidebar': toggleButton,
    'disable-sidebar': !toggleButton,
  }
  );

  const handleDropdownToggle = (name) => {
    const newMapping = {
      ...dropdownOpen,
      [name]: !dropdownOpen[name],
    };
    setDropdownOpen(newMapping);
    statesStore.mapping = newMapping;
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredCategories = Object.keys(sideBarDataset)
    .filter(key =>
      sideBarDataset[key].some(sub => sub.title.toLowerCase().includes(searchQuery.toLowerCase()))
    )
    .reduce((acc, key) => {
      acc[key] = sideBarDataset[key].filter(sub => sub.title.toLowerCase().includes(searchQuery.toLowerCase()));
      return acc;
    }, {});

  useEffect(() => {
    setDropdownOpen(
      statesStore.mapping ||
      Object.keys(sideBarDataset).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {})
    );
  }, [sideBarDataset]);


  return (
    <>
      <div className={toggleSideClass}>
        <div className="flex flex-row my-5 font-bold text-lg">
          <h1>ESTUDO <span className="text-primary">EPIDEMIOLÓGICO </span></h1>
        </div>
        <div className="w-10/12 ml-3 text-input">
          <label>Pesquisar relatorio</label>
        </div>
        <div className="relative text-center mb-8 mx-3 w-4/5">
          <input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={handleSearchChange}
            className="input-search"
          />
          <SearchIcon className="search-icon" />
        </div>
        <NavLink className="flex w-10/12 h-20 border border-gray-500 rounded-xl mb-6 justify-center items-center cursor-pointer hover:bg-gray-200"
          to="/research-progress"
          onClick={() => {
            statesStore.selectedIndicador = 0;
            setSelectedIndicador(0);
          }}>
          <HomeIcon className="text-gray-600 mr-2" />
          <label className="cursor-pointer">Pagina inicial</label>
        </NavLink>
        <label className="w-10/12 ml-3 text-input">Indicadores</label>
        <div className="list-categories h-full">
          {dropdownOpen && Object.keys(filteredCategories).map((key) => {
            let subCategory = sideBarDataset[key];
            if (subCategory) {
              const isDropdownOpen = dropdownOpen[key];
              const dropdownClasses = classNames("nav-link dropdown", {
                open: isDropdownOpen,
              });
              return (
                <div key={key} className={dropdownClasses}>
                  <div className="cursor-pointer" onClick={() => handleDropdownToggle(key)}>
                    <div className="cursor-pointer flex justify-between items-center px-2 text-lg leading-10">
                      {key}
                      {isDropdownOpen ? (
                        <KeyboardArrowDownIcon className="mr-1" />
                      ) : (
                        <KeyboardArrowRightIcon className="mr-1" />
                      )}
                    </div>
                  </div>
                  {isDropdownOpen && (
                    <div className="dropdown-content">
                      {subCategory.map((sub, index) => (
                        <div
                          key={sub.title + index}
                          className="nav-link-dropdown-item"
                        >
                          <NavLink
                            to={`/indicators/${sub.id}`}
                            className={classNames('nav-link-subitem pr-3 border-gray-200 border-b-2', {
                              'dark-primary bg-gray-200': selectedIndicador === sub.id || statesStore.selectedIndicador === sub.id
                            })}
                            onClick={() => {
                              statesStore.selectedIndicador = sub.id
                              setSelectedIndicador(sub.id)
                            }}
                          >
                            {sub.title}
                          </NavLink>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            }
            return null
          })}
        </div>
        <div className="flex h-24">
          <MenuLogin />
        </div>
      </div>
      <div className={toggleSideClassRecoilButton}
        onClick={() => {
          handleClickCloseMenu()
        }}>
        <ArrowBackSharp
          className=""
        />
      </div>
    </>
  );
};

export default SideBar;